import { useOutsideClick } from "hooks/useOutsideClick";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { transferConversationStart } from "../../../redux/chats/chats.actions";
import { DEFAULT_AVATAR_URL } from "utils/constants";
import Modal from "../../Modal";
import ModalBody from "../../Modal/ModalBody";
import ModalFooter from "../../Modal/ModalFooter";
import useTranslation from "hooks/useTranslation";
import useMediaQuery from "use-mediaquery";

const getAgents = ({ userData }) => userData.agents;
const getSelectedConversation = ({ chatsData }) =>
  chatsData.selectedConversation;
const getAgent = ({ userData }) => userData.agent;

const ForwardToOperator = () => {
  const agents = useSelector(getAgents);
  const selectedConversation = useSelector(getSelectedConversation);
  const agent = useSelector(getAgent);

  const [activeAgent, setActiveAgent] = useState(null);
  const [searchingAgents, setSearchingAgents] = useState("");
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [showAgents, setShowAgents] = useState(false);
  const dispatch = useDispatch();
  const dropDownRef = useRef(null);
  useOutsideClick(dropDownRef, () => {
    setShowAgents(false);
  });
  const { getTranslation } = useTranslation(["CHAT", "COMMON"]);
  const { t } = getTranslation();
  const isSmallDevice = useMediaQuery("(max-width: 650px)");
  const showOperatorsImage = !isSmallDevice;

  const filteredAgentsList = agents.data.filter(
    ({ id, name, lname, avatar }) => {
      return (
        !searchingAgents ||
        (searchingAgents &&
          name &&
          name.toLowerCase().includes(searchingAgents.toLowerCase())) ||
        (searchingAgents &&
          lname &&
          lname.toLowerCase().includes(searchingAgents.toLowerCase()))
      );
    }
  );

  const handleSelectAgent = (agentId, event) => {
    event.stopPropagation();
    setShowTransferModal(true);
    setActiveAgent(agentId);
  };

  const handleTransferConversation = () => {
    let conversationInfo = {
      conversationId: selectedConversation.conversation.id,
      targetAgent: activeAgent,
      transferred: agent.data.id,
    };
    dispatch(transferConversationStart(conversationInfo));
    setShowTransferModal(false);
  };

  return (
    <>
      <Modal
        setVisibility={setShowTransferModal}
        visible={showTransferModal}
        className="confirmation-modal"
      >
        <ModalBody>
          <div>
            <div className="conv__body__header_block_user_modal_title">
              {t("MODAL").TRANSFER_CONV_TITLE}
            </div>
            <div className="conv__body__header_block_user_modal_select">
              {t("MODAL").TRANSFER_CONV_CONFIRM}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="modal__container__footer__left">
            <button
              onClick={() => setShowTransferModal(false)}
              className="btn btn-tertiary"
              id="closeModal"
            >
              {t("MODAL").CANCEL}
            </button>
            <button
              onClick={() => handleTransferConversation()}
              className="btn btn-primary"
            >
              {t("MODAL").CONFIRM}
            </button>
          </div>
        </ModalFooter>
      </Modal>

      <div ref={dropDownRef} style={{ position: "relative" }}>
        <div
          ref={dropDownRef}
          onClick={() => setShowAgents(!showAgents)}
          className="conv__body__header__right__assign select-box flex flex-ai-c"
        >
          {Object.keys(agent.data).length > 0 && (
            <div className="default flex flex-ai-c">
              {showOperatorsImage && (
                <img
                  className="select-box__image"
                  src={agent.data.avatar}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = DEFAULT_AVATAR_URL;
                  }}
                  alt=""
                />
              )}
              <p className="select-box__text">{t("YOU")}</p>
            </div>
          )}
        </div>

        <div
          className={`optionlist operators-list ${
            showAgents ? "showDropDown" : "hideDropDown"
          }`}
        >
          <div className="optionlist__filter flex">
            <input
              onChange={(e) => setSearchingAgents(e.target.value)}
              value={searchingAgents}
              type="text"
              placeholder={t("SEARCH") + "..."}
            />
          </div>
          <div className="optionlist__inner">
            {!!filteredAgentsList.length && (
              <div className="optionlist__inner__subtitle">
                {t("TRANSFER_CONV")}
              </div>
            )}

            {!!filteredAgentsList.length ? (
              filteredAgentsList.map(({ id, name, lname, avatar }) => {
                return (
                  <div
                    onClick={(e) => handleSelectAgent(id, e)}
                    key={id}
                    className={`option flex flex-ai-c ${
                      activeAgent === id && "active"
                    }`}
                  >
                    {showOperatorsImage && (
                      <img
                        src={avatar}
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null; // prevents looping
                          currentTarget.src = DEFAULT_AVATAR_URL;
                        }}
                        alt=""
                        className="option__image"
                      />
                    )}
                    <p className="option__text">{name + lname}</p>
                  </div>
                );
              })
            ) : (
              <div className="optionlist__inner__subtitle">
                {t("AGENT_NOT_FOUND")}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ForwardToOperator;
